import type { TournamentCopyNotice } from "./api";

/** Aviso «Copia de …» guardado en la copia por el backend (duplicar torneo,
 * Eduardo 2026-10-03). Lectura defensiva: cualquier forma rara = sin aviso. */
export function copyNoticeFromPolicy(policy: Record<string, unknown> | null | undefined): TournamentCopyNotice | null {
  const raw = policy && typeof policy === "object" ? (policy as Record<string, unknown>).copied_from : null;
  if (!raw || typeof raw !== "object") return null;
  const entry = raw as Record<string, unknown>;
  if (typeof entry.name !== "string" || !entry.name.trim()) return null;
  return {
    tournament_id: typeof entry.tournament_id === "number" ? entry.tournament_id : 0,
    name: entry.name,
    whatsapp_groups_removed: typeof entry.whatsapp_groups_removed === "number" ? entry.whatsapp_groups_removed : 0,
    ranking_linked: entry.ranking_linked === true,
    call_pdf_removed: entry.call_pdf_removed === true,
    birth_year_shift: typeof entry.birth_year_shift === "number" && entry.birth_year_shift !== 0 ? entry.birth_year_shift : null,
    payment_setup_reset: entry.payment_setup_reset === true,
    platform_fee_review: entry.platform_fee_review === true,
  };
}
